import { Form, Dropdown } from 'semantic-ui-react'

const MultiSelectDropdownField = ({
  options,
  ...rest
}: {
  options: string[]
  [key: string]: any
}) => {
  return (
    <Form.Field
      control={Dropdown}
      fluid
      multiple
      search
      selection
      clearable
      options={options.map(cat => ({
        key: cat,
        text: cat,
        value: cat,
      }))}
      {...rest}
    />
  )
}

export default MultiSelectDropdownField
